interface Language {
  code: string;
  label: string;
  labelShort: string;
}

interface I18nConfig {
  locales: string[];
  defaultLocale: string;
  languages: Language[];
  spaces: string[];
}

const i18nConfig: I18nConfig = {
  locales: ['en', 'es', 'de', 'it', 'zh-CN'],
  defaultLocale: 'en',
  languages: [
    { code: 'en', label: 'English', labelShort: 'EN' },
    { code: 'es', label: 'Español', labelShort: 'ES' },
    { code: 'it', label: 'Italiano', labelShort: 'IT' },
    { code: 'de', label: 'Deutsch', labelShort: 'DE' },
    { code: 'zh-CN', label: '简体中文', labelShort: '中文' },
  ],
  spaces: ['translation'],
};
export default i18nConfig;
